<svg viewBox="0 0 322 327" fill="none" xmlns="http://www.w3.org/2000/svg" {...$$restProps}>
	<path d="M313.479 327L321.15 313.714H305.808L313.479 327Z" fill="#4E260D" />
	<path
		fill-rule="evenodd"
		clip-rule="evenodd"
		d="M119.662 25.8023C81.7246 10.088 41.0634 2 0.00012207 2V0C41.326 0 82.2473 8.13974 120.428 23.9545C158.608 39.7692 193.299 62.9493 222.521 92.1711C251.743 121.393 274.923 156.084 290.738 194.265C306.552 232.445 314.692 273.366 314.692 314.692H312.692C312.692 273.629 304.604 232.967 288.89 195.03C273.176 157.092 250.143 122.621 221.107 93.5854C192.071 64.5492 157.6 41.5165 119.662 25.8023Z"
		fill="#4E260D"
	/>
</svg>
